import { createApp } from "vue";
import WaitlistApp from "./WaitlistApp.js";

createApp(WaitlistApp).mount("#app");
